import React from "react";
import { RouteComponentProps } from "react-router";
import { UserDetails } from "../UserDetails";

export const AdministratorDetails: React.FC<RouteComponentProps<any>> = (props) => (
  <UserDetails {...props} viewType="administrators" />
);
